export default "__VITE_ASSET__5kFbjCkj__"